import { Chart } from 'chart.js';
import { scales, color_rose, color_blue } from "./ChartConfig";
export default function TileObjectsChart(ctx, tileLayer) {
  var lastValidCompareIndex = 0;
  var timestamp = Date.now();
  var viewLevelStartDataset = {
    label: 'Update 1st level',
    data: [{
      x: 0,
      y: 0
    }],
    borderColor: color_rose,
    borderWidth: 1.5,
    pointRadius: 1
  };
  var viewUpdateDurationDataset = {
    label: 'Update duration (ms)',
    data: [{
      x: 0,
      y: 0
    }],
    borderColor: color_blue,
    borderWidth: 1.5,
    pointRadius: 1
  };
  var label = ['0s'];
  var nbObjectsChart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: label,
      datasets: [viewLevelStartDataset, viewUpdateDurationDataset]
    },
    options: {
      animation: {
        duration: 10
      },
      scales: scales
    }
  });
  this.update = function (displayed, updateDuration) {
    // update line graph
    // update time
    var limit = 60;
    var timeInS = Math.floor((Date.now() - timestamp) / 1000);
    var lbl = "".concat(timeInS, "s");
    var identical = lastValidCompareIndex > 0 && label[lastValidCompareIndex] == lbl;
    if (identical) {
      label.push('');
    } else {
      label.push(lbl);
      lastValidCompareIndex = label.length - 1;
    }
    if (label.length > limit) {
      label.shift();
      lastValidCompareIndex--;
    }
    viewLevelStartDataset.data.push({
      x: 0,
      y: tileLayer._latestUpdateStartingLevel
    });
    viewUpdateDurationDataset.data.push({
      x: 0,
      y: updateDuration
    });
    if (viewLevelStartDataset.data.length > limit) {
      viewLevelStartDataset.data.shift();
      viewUpdateDurationDataset.data.shift();
    }
    if (displayed) {
      nbObjectsChart.update();
    }
  };
  this.resize = function () {
    nbObjectsChart.resize();
  };
}